// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3TBAk","dragIcon":"Choice_dragIcon__3QSW7","left":"Choice_left__1FG-H","input":"Choice_input__1KGSR"};